module.exports = __webpack_public_path__ + "img/avatar-r0.5c3e2642.svg";